export const formatAnnotationsCount = (annotationsCount, slidesLength) =>
  `${annotationsCount}${slidesLength > 1 ? '+' : ''}`;

export const getShowAnnotationsCount = (
  annotationsCount,
  currentSlide,
  slidesViewerProps,
) =>
  !!(
    (annotationsCount && currentSlide.uuid === annotationsCount.slideUUID) ||
    (annotationsCount && !slidesViewerProps)
  );
